function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 512.04852 511.95504",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#feb239",
      stroke: "#feb239",
      strokeWidth: 1.39688,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    d: "M 238.59388,505.14511 C 207.88795,487.05861 157.44307,445.9574 128.96966,415.82604 57.543337,340.24078 17.106583,251.64717 3.499841,140.93191 2.1116913,129.6368 0.86943135,104.70889 0.73927242,85.536549 0.47186954,46.149928 1.1250875,44.248541 17.766948,35.973134 38.786424,25.520889 105.11905,10.687306 159.40929,4.2984564 c 40.62889,-4.78119411 155.28045,-4.78579573 194.10081,-0.00719 57.51296,7.0786796 111.94642,19.3711596 139.33087,31.4645306 16.93286,7.477799 18.50935,11.231123 18.50935,44.067352 0,52.251521 -7.86117,106.481301 -22.49216,155.160681 -10.26807,34.16338 -19.5782,55.64611 -39.34093,90.77783 -27.08317,48.14506 -57.06276,84.48251 -102.43016,124.15292 -25.92961,22.67351 -66.06171,52.02568 -79.34427,58.03148 -11.14081,5.03741 -16.75887,4.49769 -29.14892,-2.80034 z",
    id: "path1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0.364789,
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill"
    },
    d: "M 153.18586,311.61148 C 67.805263,171.9543 50.714893,143.69306 51.305643,143.13871 52.705663,141.82497 255.73067,21.412443 256.30001,21.558173 c 0.827,0.21167 203.61253,120.786997 204.44515,121.562097 0.56014,0.52146 -18.26879,31.64544 -101.55374,167.86694 -56.23275,91.97473 -102.50554,167.49773 -102.82843,167.82887 -0.43871,0.44993 -26.51413,-41.80681 -103.17713,-167.2046 z m 86.4215,5.54905 0.37606,-76.63096 -63.71289,-27.72697 c -35.04209,-15.24983 -63.80579,-27.63406 -63.91935,-27.5205 -0.1885,0.18851 124.87293,206.60054 126.10302,208.13114 0.29349,0.36521 0.5884,0.59971 0.65536,0.52113 0.0669,-0.0786 0.29098,-34.62681 0.4978,-76.77384 z m 97.1117,-27.40682 c 34.77368,-57.3372 63.13066,-104.34368 63.01552,-104.45882 -0.11516,-0.11515 -28.89775,12.27672 -63.96136,27.53747 l -63.752,27.74683 0.34565,50.76636 c 0.19011,27.9215 0.34565,62.4529 0.34565,76.73643 0,14.28355 0.17588,25.95908 0.39085,25.94562 0.21496,-0.0135 28.84202,-46.93669 63.61569,-104.27389 z M 239.74204,135.78513 c -0.16794,-40.870086 -0.41544,-74.419327 -0.54998,-74.553877 -0.38237,-0.38236 -136.36194,79.228127 -136.32699,79.813867 0.0171,0.28661 1.37079,2.74895 3.00818,5.47183 l 2.97709,4.95071 65.12476,29.26554 c 35.81861,16.09606 65.33796,29.28707 65.59852,29.31338 0.28356,0.0286 0.35117,-29.78587 0.16842,-74.26145 z m 97.31799,45.39397 c 34.96122,-15.67752 64.17937,-28.82186 64.92925,-29.20963 1.2046,-0.62293 7.25842,-9.81151 7.25842,-11.01695 0,-0.53339 -136.00804,-80.080037 -136.3446,-79.743477 -0.13271,0.13271 -0.38541,33.725991 -0.56159,74.651727 -0.27545,63.99511 -0.21721,74.36932 0.41621,74.11669 0.40506,-0.16157 29.34111,-13.12083 64.30231,-28.79836 z",
    id: "path1-3-6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.98a004a1.svg";
export { ForwardRef as ReactComponent };